import { EmpathizeState, Point } from '../../../models';
import { EMPATHIZE_MUTATIONS_KEYS } from '../empathize.const';
import { EmpathizeMutation } from '../empathize.interfaces';

export class SetSelectedIndexMutation implements EmpathizeMutation {
  mutations = {
    [EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex]: (localState: EmpathizeState, newSelectedIndex: number) => {
      localState.selectedIndex = newSelectedIndex;
    },
    [EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock]: (localState: EmpathizeState, newSelectedEmpathizeBlock: Partial<Point>) => {
      Object.assign(localState.selectedEmpathizeBlock, newSelectedEmpathizeBlock);
    }
  };
}
